import React, { useEffect } from 'react';
import Box from '../../../../components/Layout/Components/Box/Box';
import AssignmentIcon from '@material-ui/icons/Assignment';
import BoxHeaderIcon from '../../../../components/Layout/Components/Box/Header/BoxHeaderIcon';
import BoxHeader from '../../../../components/Layout/Components/Box/Header/BoxHeader';
import { useDispatch } from 'react-redux';
import useReduxReducer from '../../../../hooks/useReduxReducer';
import closure from './Closure/reducers';
import { getDataForClosureAction } from './Closure/actions';

const Closure = () => {
  useReduxReducer({ closure });

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getDataForClosureAction());
  }, [dispatch]);

  return (
    <>
      <Box>
        <BoxHeader>
          <BoxHeaderIcon color={'#43a047'}>
            <AssignmentIcon />
          </BoxHeaderIcon>
        </BoxHeader>
      </Box>

    </>
  );
};

export default Closure;
